import React, { useState } from "react";
import { dateFormat, dateTimeFormat } from "../../../utils/formats";
import { Button, DialogTrigger } from "@fluentui/react-components";
import {
  DataGrid,
  createTableColumn,
  TableCellLayout,
  DataGridBody,
  DataGridHeader,
  DataGridRow,
  DataGridHeaderCell,
  DataGridCell
} from "@fluentui/react-components";

export default function Addnotes({ notesList, handleClose, handleAddNote }) {
  const [selectedNote, setSelectedNote] = useState([]);
  const [selectedGridItem, setSelectedGridItem] = useState(new Set([]));

  const [isOpen, setIsOpen] = useState(false);

  const handleViewNote = (note) => {
    let selectedValue = [];
    for (const value of selectedGridItem) {
      selectedValue.push(value);
    }

    const filterNotes = notesList.filter(x => selectedValue.includes(x.notePadID));
    setSelectedNote(pre => pre = filterNotes || []);
    setIsOpen(true);
  };

  const columns = [
    createTableColumn({
      columnId: "addDate",
      renderHeaderCell: () => "Date",
      renderCell: (item) => {
        return <TableCellLayout>{dateFormat(item.addDate)}</TableCellLayout>;
      },
    }),
    createTableColumn({
      columnId: "addUser",
      renderHeaderCell: () => "Added By",
      renderCell: (item) => {
        return <TableCellLayout>{item.addUser}</TableCellLayout>;
      },
    }),
    createTableColumn({
      columnId: "note",
      renderHeaderCell: () => "Notes",
      renderCell: (item) => {
        return <TableCellLayout className="notelimit" style={{width:'200px'}}>{item.note}</TableCellLayout>;
      },
    }),
  ];
  return (
    <>
      <div className="p-0">
        {!isOpen && <div className="relative h-auto">
          <h2 className="h2-text text-xl font-bold mb-3">Policy Notes</h2>
          <div className="overflow-y-auto h-full mb-3 -mt-2.5">
          <DataGrid
            selectionMode={"multiselect"}
            items={notesList}
            columns={columns}
            selectedItems={selectedGridItem}
            onSelectionChange={(_, data) => setSelectedGridItem(data.selectedItems)}
            getRowId={(item) => item.notePadID}
            focusMode="composite"
            // className="grid-tbl"
          >
            <DataGridHeader style={{ color: "#fff", background: "#102246", borderRadius:'4px', height: "32px" }}>
              <DataGridRow>
                {({ renderHeaderCell }) => (
                  <DataGridHeaderCell style={{color: "#fff"}} className="cell-styl">{renderHeaderCell()}</DataGridHeaderCell>
                )}
              </DataGridRow>
            </DataGridHeader>
            <DataGridBody className="h-72 overflow-y-auto">
              {({ item, rowId }) => (
                <DataGridRow key={rowId} style={{ height: '26px' }}>
                  {({ renderCell }) => <DataGridCell className="cell-styl">{renderCell(item)}</DataGridCell>}
                </DataGridRow>
              )}
            </DataGridBody>
          {/* {notesList.length == 0 && <div>No Result Found</div>} */}
          </DataGrid>
              </div>

           <div className="rounded-md fixed bottom-0 left-0 right-0 flex justify-end h-12 mr-1 gap-2 py-2 bg-white shadow-md">

            <Button 
            className="btn-com"
            onClick={handleAddNote}>
              Add Note
            </Button>

            <Button 
            className={`${(selectedGridItem?.size <= 0)? "btn-com-disable": "btn-com"}`}
            disabled={selectedGridItem?.size <= 0} 
            onClick={handleViewNote}>
              View Note
            </Button>
            <DialogTrigger disableButtonEnhancement>
              <Button
                className="btn-com-cancel"
                 onClick={handleClose}
              >
                Close
              </Button>
            </DialogTrigger>
          </div>
        </div>}
        {/* Modal */}
        {isOpen && (

<div className="relative">
   <div className="relative">
  <h3 className="h2-text text-lg font-bold mb-2 text-gray-800">Note Details</h3>
  <div className="overflow-y-auto h-80 min-h-72 mb-6 border border-[#E4E4E7] p-1.5 grid-tbl">
    {selectedNote.map((n, index) => (
      <React.Fragment key={index}>
        <div className="note-card bg-white rounded-lg shadow-lg p-2 my-1  w-99 transition-transform transform hover:-translate-y-0.5 hover:shadow-xl">
        <p className="relative note-details mb-4 pb-1" >
        
        <span className="text-sm text-gray-600"> Notes made on:</span>
        <span style={{color: "##09090B"}}> {dateTimeFormat(n?.addDate)}</span> 
        <span className="text-sm text-gray-600">  by </span>
        <span style={{ color: "##09090B" }}>{n?.addUser} </span>
            <span class="absolute bottom-0 left-0 w-2/3 border-b-2 border-[#E4E4E7]"></span>
        </p>
        <p className="note-content text-sm text-gray-600 mb-4">
          {n.note}
        </p>
        </div>
      </React.Fragment>
    ))}
  </div>
  <div className="rounded-md fixed bottom-0 left-0 right-0 flex justify-end h-12 mr-1 gap-2 py-2 bg-white shadow-md">
    <DialogTrigger disableButtonEnhancement>
      <Button 
       className="btn-com-cancel"
      onClick={() => setIsOpen(false)}>
        Close
      </Button>
    </DialogTrigger>
  </div>
</div>

          </div>
        )}
      </div>
    </>
  );
}
